import {
  ErrorMessageEntities,
  ErrorSpesificationModal
} from "@/domain/entities/MainApp";
import {
  CLIENT_ERROR,
  INTERNAL_SERVER_ERROR,
  INTERNET_ERROR,
  RATE_LIMIT_ERROR
} from "@/app/infrastructures/misc/Constants";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { getToken } from "../Cookies";

function getI18nInstance() {
  // Lazy-load i18n only when needed to prevent import cycles.
  return require("@/i18n").default;
}

/** Same as `i18n.global.t` for non-Vue modules (uses active global locale). */
export function $t(key: string): string {
  return String(getI18nInstance().global.t(key));
}

type ApiMessage = { id?: string; en?: string };

/** Picks `id` vs `en` from API `message` objects using active i18n locale (`my`/`en` → English). */
export function resolveApiBilingualMessage(
  message: ApiMessage | string | undefined | null
): string {
  if (message == null) return "";
  if (typeof message === "string") return message;
  const rawLocale = getI18nInstance().global.locale as
    | string
    | { value?: string };
  const loc =
    typeof rawLocale === "string" ? rawLocale : rawLocale?.value ?? "id";
  if (loc === "id") {
    return message.id ?? message.en ?? "";
  }
  return message.en ?? message.id ?? "";
}

export const ERROR_SPESIFICATION = (error: string): ErrorSpesificationModal => {
  switch (error) {
    case "Destination Forward Rate price for selected route is not available":
    case "Origin Forward Rate price for selected route is not available":
    case "Shipping Surcharge and Publish Rate price for selected route is not available":
    case "Harga Shipping Surcharge dan Publish Rate untuk rute yang dipilih tidak tersedia":
    case "Harga Origin Forward Rate  dan REGPACK untuk rute yang dipilih tidak tersedia":
      return new ErrorSpesificationModal({
        headerError: $t("parsingErrorSpec.rateNotFoundHeader"),
        errorMsg: $t("parsingErrorSpec.rateNotFoundMessage"),
        statusError: true,
        errorDestination: false,
        isErrorEmbargo: false
      });

    case "Unacceptable due to an embargo":
    case "Tidak dapat diproses karena embargo":
      return new ErrorSpesificationModal({
        headerError: $t("parsingErrorSpec.embargoHeader"),
        errorMsg: $t("parsingErrorSpec.embargoMessage"),
        statusError: true,
        errorDestination: false,
        isErrorEmbargo: true
      });

    case "Tidak bisa booking. Saldo dibawah minimum balance saldo yang ditentukan":
      return new ErrorSpesificationModal({
        headerError: $t("parsingErrorSpec.balanceBelowHeader"),
        errorMsg: $t("parsingErrorSpec.balanceBelowMessage"),
        statusError: true,
        errorDestination: false,
        isErrorEmbargo: false
      });

    case "Silakan hubungi pihak POS untuk top up saldo untuk perubahan alamat.":
      return new ErrorSpesificationModal({
        headerError: $t("parsingErrorSpec.posBalanceHeader"),
        errorMsg: $t("parsingErrorSpec.posBalanceMessage"),
        statusError: true,
        errorDestination: false,
        isErrorEmbargo: false
      });

    default:
      return new ErrorSpesificationModal({
        headerError: $t("parsingErrorSpec.requestFailedHeader"),
        errorMsg: error,
        statusError: false,
        errorDestination: false,
        isErrorEmbargo: false
      });
  }
};

const parsingErrorResponse = (
  err: any,
  title?: string,
  onTryAgain?: Function,
  onClose?: Function
): ErrorMessageEntities => {
  const localeAccount = AccountController.accountData.account_type_detail.countryCode.toLocaleLowerCase();
  if (!err.response) {
    return new ErrorMessageEntities({
      type: INTERNET_ERROR,
      onTryAgain: onTryAgain,
      onClose: onClose,
      title: title
    });
  }
  if (err.response.status === 429) {
    return new ErrorMessageEntities({
      type: RATE_LIMIT_ERROR
    });
  }
  if (err.response.status < 500) {
    return new ErrorMessageEntities({
      type: CLIENT_ERROR,
      message:
        (localeAccount === "id" && getToken()
          ? err.response?.data?.message?.id
          : err.response?.data?.message?.en) || err?.message,
      title: title,
      onClose: onClose,
      onTryAgain: onTryAgain,
      code: err?.response?.data?.code
    });
  }
  return new ErrorMessageEntities({
    type: INTERNAL_SERVER_ERROR,
    onTryAgain: onTryAgain,
    onClose: onClose
  });
};
export default parsingErrorResponse;
